export default __webpack_public_path__ + "static/pic-8-cbab1ca3335ed9a8414dc5beac00f615.png";